import { render, staticRenderFns } from "./GroupSizes.vue?vue&type=template&id=811a92b6"
import script from "./GroupSizes.vue?vue&type=script&lang=js"
export * from "./GroupSizes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports